export const UnitFinancialFees = [
  {
    key: 'showTransferFees',
    label: 'Show Transfer Fees',
    isForSale: true,
  },
  {
    key: 'showAgencyFees',
    label: 'Show Agency Fees',
    isForSale: true,
  },
  {
    key: 'showNOCFeeBuyer',
    label: 'Show NOC Fee Buyer',
    isForSale: true,
  },
  {
    key: 'showServiceCharge',
    label: 'Show Service Charge',
    isForSale: true,
  },
  {
    key: 'showChillerCharges',
    label: 'Show Chiller Charges',
  },
  {
    key: 'showLeased',
    label: 'Show Leased',
  },
  {
    key: 'showCurrentRentAmount',
    label: 'Show Current Rent Amount',
  },
  {
    key: 'showRentalExpiryDate',
    label: 'Show Rental Expiry Date',
  },
  {
    key: 'showPaymentModeDetails',
    label: 'Show Payment Mode Details',
    isForLease: true,
  },
  {
    key: 'showNumberOfPayment',
    label: 'Show Number of Payments',
    isForLease: true,
  },
  {
    key: 'showCommissionFees',
    label: 'Show Commission Fees',
    isForLease: true,
  },
  {
    key: 'showSecurityDeposit',
    label: 'Show Security Deposit',
    isForLease: true,
  },
];
